var map = {
	"./bland.png": 260,
	"./cali.png": 492,
	"./carni.png": 148,
	"./fodmap.png": 262,
	"./ifa.png": 63,
	"./life.png": 163,
	"./med.png": 919,
	"./pcos.png": 488,
	"./pilates.png": 129,
	"./rice.png": 654
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 518;